import React from 'react';
import { Star, Package, Globe, ShieldCheck } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-gray-300 py-2.5 px-3 border-y border-white/5" data-id="element-239">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[10px] md:text-xs font-medium text-center" data-id="element-240">
        <div className="flex items-center gap-1" data-id="element-241">
          <Star className="w-3 h-3 text-brand-gold fill-current" data-id="element-242" />
          <span data-id="element-243">4.9/5</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-244">•</span>
        <div className="flex items-center gap-1" data-id="element-245">
          <Package className="w-3 h-3 text-brand-accent" data-id="element-246" />
          <span data-id="element-247">6 tomos + 4 bonos</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-248">•</span>
        <div className="flex items-center gap-1" data-id="element-249">
          <Globe className="w-3 h-3 text-brand-accent" data-id="element-250" />
          <span data-id="element-251">Todo LATAM</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-252">•</span>
        <div className="flex items-center gap-1" data-id="element-253">
          <ShieldCheck className="w-3 h-3 text-brand-accent" data-id="element-254" />
          <span data-id="element-255">Garantía 7 días</span>
        </div>
      </div>
    </div>;
}